"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sat = exports.SatResource = exports.CreateSatPayload = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Field = __importStar(require("../../../openapi/field"));
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Auth.Schema';
exports.CreateSatPayload = effect_1.Schema.Struct({
    resourceType: effect_1.Schema.propertySignature(effect_1.Schema.Literal('device').annotations({
        description: 'Type of resource. Only device is supported.',
    })),
    // Runtime: `body('resourceId').notEmpty()` only — a numeric id can pass.
    // The contract documents a string (device ids are strings).
    resourceId: effect_1.Schema.propertySignature(effect_1.Schema.String.pipe(effect_1.Schema.nonEmptyString()).annotations({
        description: 'Identifier of the resource (device id).',
    })),
    access: effect_1.Schema.optionalWith(effect_1.Schema.Literal('read', 'write').annotations({
        description: 'Stored grant (default read). Not checked at issuance and not applied by SatCredentialRouteGuard; consuming endpoints that check SAT access enforce it.',
    }), {
        exact: true,
        default: () => 'read',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.CreateSatPayload`,
    description: 'Request body to create a short-lived access token for a device',
});
exports.SatResource = effect_1.Schema.Struct({
    id: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({ description: 'Resource identifier' }),
    type: effect_1.Schema.propertySignature(effect_1.Schema.Literal('device')).annotations({ description: 'Resource type' }),
    access: effect_1.Schema.propertySignature(effect_1.Schema.Literal('read', 'write').annotations({
        description: 'Stored grant for this resource. Not applied at issuance or by SatCredentialRouteGuard; consuming endpoints that check SAT access enforce it.',
    })),
}).annotations({
    identifier: `${exports.NAMESPACE}.SatResource`,
});
exports.Sat = effect_1.Schema.Struct({
    id: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'Opaque SAT identifier. Pass it as the `sat` query parameter on endpoints that accept SatCredential authentication.',
    }),
    resources: effect_1.Schema.propertySignature(effect_1.Schema.Array(exports.SatResource)).annotations({
        description: 'Resources the SAT may access',
    }),
    issuedTo: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'User id the SAT was issued to',
    }),
    createdAt: effect_1.Schema.propertySignature(Field.dateTime('ISO-8601 creation time')).annotations({
        description: 'ISO-8601 creation time',
    }),
    expiresAt: effect_1.Schema.propertySignature(Field.dateTime('ISO-8601 expiry. TTL is 3600 seconds from issue.')).annotations({
        description: 'ISO-8601 expiry. TTL is 3600 seconds from issue.',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.Sat`,
    description: 'Created short-lived access token',
});
//# sourceMappingURL=schema.js.map